import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import * as motorActions from 'external/reduxBits/motor/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'

import { sliderValues } from './sliderValues'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    // No globals needed
    ...{
      objectCustom: undefined,
      event: 'event',
      objectType: 'UIElement',
      target: {
        type: 'ClassifiedAd',
        id: _.get(state.classified.requestedAd, 'ad.listId'),
        name: _.get(state.classified.requestedAd, 'ad.subject'),
        category: ' ',
      },
    },
    ...localData,
  })

export const financeInfoShowed = {
  validators: [
    validators.redux(motorActions.FINANCE_INFO_SHOWED, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state, accumulator }) => {
      return createDataLayerObject(state, {
        objectId: 'motor_finance_info_show',
        objectName: 'Motor finance info show',
        eventType: 'Show',
        objectType: 'Content',
        objectCustom: {
          motorFinanceCompanyId: _.get(state.motor, 'financeData.data.companyName'),
          motorFinanceCash: _.get(state.motor, 'financeWidgetSettings.cash'),
          motorFinanceTime: _.get(state.motor, 'financeWidgetSettings.months'),
          motorFinanceResidualValue:
            (_.get(state.motor, 'financeWidgetSettings.salvageValue') / 100) *
            _.get(state.classified.requestedAd, 'ad.price.value'),
          motorFinanceMonthlyPrice: _.get(accumulator, 'monthlyPrice'),
        },
      })
    }),
  ],
}

export const sliderChangedCash = {
  validators: [
    validators.redux(motorActions.CASH_SLIDER_CHANGED, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state }) => {
      return createDataLayerObject(state, {
        objectId: 'motor_finance_slider_interaction_cash',
        objectName: 'Motor finance slider interaction cash',
        eventType: 'Update',
      })
    }),
  ],
}

export const sliderChangedMonths = {
  validators: [
    validators.redux(motorActions.MONTHS_SLIDER_CHANGED, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state }) => {
      return createDataLayerObject(state, {
        objectId: 'motor_finance_slider_interaction_time',
        objectName: 'Motor finance slider interaction time',
        eventType: 'Update',
      })
    }),
  ],
}

export const sliderChangedSalvageValue = {
  validators: [
    validators.redux(
      motorActions.SALVAGE_VALUE_SLIDER_CHANGED,
      () => true,
      ({ payload }) => payload,
    ),
  ],
  events: [
    gtm.event(({ state }) => {
      return createDataLayerObject(state, {
        objectId: 'motor_finance_slider_interaction_residual',
        objectName: 'Motor finance slider interaction residual',
        eventType: 'Update',
      })
    }),
  ],
}

export const slidersChanged = {
  validators: [
    validators.redux(motorActions.SLIDERS_CHANGED, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state, accumulator }) => {
      return createDataLayerObject(state, {
        objectId: 'motor_finance_slider_values_changed',
        objectName: 'Motor finance slider values changed',
        eventType: 'Update',
        objectCustom: {
          ...sliderValues(state, accumulator),
        },
      })
    }),
  ],
}

export const openedFinanceWidget = {
  validators: [validators.redux(motorActions.CLICKED_OPEN_FINANCE_WIDGET)],
  events: [
    gtm.event(({ state }) => {
      return createDataLayerObject(state, {
        objectId: 'motor_finance_widget_opened',
        objectName: 'Motor finance widget open',
        eventType: 'Engagement',
      })
    }),
  ],
}

export const shortcutLinkClicked = {
  validators: [validators.redux(motorActions.CLICKED_LINK_TO_FINANCE)],
  events: [
    gtm.event(({ state }) => {
      return createDataLayerObject(state, {
        objectId: 'motor_finance_shortcut_link',
        objectName: 'Motor finance shortcut link',
        eventType: 'Engagement',
      })
    }),
  ],
}
